<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hz7IS6/tc-custom/9781466860452.jpg?1729379520048" alt="This image is the cover for the book Caught in the Revolution"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Caught in the Revolution
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From the <i>New York Times</i> bestselling author of <i>The Romanov Sisters</i>, <i>Caught in the Revolution </i>is </b><b> Helen Rappaport's</b><b> masterful telling of the outbreak of the Russian Revolution through eye-witness accounts left by foreign nationals who saw the drama unfold.</b><br/><br/>Between the first revolution in February 1917 and Lenin’s Bolshevik coup in October, Petrograd (the former St Petersburg) was in turmoil – felt nowhere more keenly than on the fashionable Nevsky Prospekt. There, the foreign visitors who filled hotels, clubs, offices and embassies were acutely aware of the chaos breaking out on their doorsteps and beneath their windows.<br/><br/>Among this disparate group were journalists, diplomats, businessmen, bankers, governesses, volunteer nurses and expatriate socialites. Many kept diaries and wrote letters home: from an English nurse who had already survived the sinking of the Titanic; to the black valet of the US Ambassador, far from his native Deep South; to suffragette leader Emmeline Pankhurst, who had come to Petrograd to inspect the indomitable Women’s Death Battalion led by Maria Bochkareva.<br/><br/>Helen Rappaport draws upon this rich trove of material, much of it previously unpublished, to carry us right up to the action – to see, feel and hear the Revolution as it happened to an assortment of individuals who suddenly felt themselves trapped in a "red madhouse."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen Rappaport
      </h2>
      
      <p class="authorDescription body article">HELEN RAPPAPORT is the <I>New York Times</I> bestselling author of <I>The Romanov Sisters</I>. She studied Russian at Leeds University and is a specialist in Russian and Victorian history. She lives in West Dorset.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c4317afa